<template>
  <vue-final-modal
    v-slot="{ params, close }"
    v-bind="$attrs"
    :attach="attach"
    classes="modal-container"
    content-class="modal-content"
  >
    <span class="modal__title mb-4">
      <slot name="title" />
    </span>
    <div
      :id="idContent"
      class="modal__content mb-2">
      <slot :params="params" />
    </div>
    <div
      v-if="confirmAction || cancelAction"
      class="modal__action mb-2"
    >
      <v-button @click="$emit('confirm', close)">
        confirm
      </v-button>
      <v-button @click="$emit('cancel', close)">
        cancel
      </v-button>
    </div>
    <button
      v-if="closeAction"
      class="modal__close d-flex justify-center align-center"
      @click="close"
    >
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="white"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M1.69659 0.282486C1.50133 0.0872236 1.18475 0.0872237 0.989487 0.282486L0.28238 0.989592C0.0871179 1.18485 0.0871181 1.50144 0.28238 1.6967L5.58568 7L0.28238 12.3033C0.0871181 12.4986 0.0871179 12.8151 0.28238 13.0104L0.989487 13.7175C1.18475 13.9128 1.50133 13.9128 1.69659 13.7175L6.99989 8.41421L12.3032 13.7175C12.4985 13.9128 12.815 13.9128 13.0103 13.7175L13.7174 13.0104C13.9127 12.8151 13.9127 12.4986 13.7174 12.3033L8.41411 7L13.7174 1.6967C13.9127 1.50144 13.9127 1.18485 13.7174 0.989592L13.0103 0.282486C12.815 0.0872234 12.4985 0.0872237 12.3032 0.282486L6.99989 5.58579L1.69659 0.282486Z" />
      </svg>
    </button>
  </vue-final-modal>
</template>

<script>
export default {
  name: 'VModal',
  inheritAttrs: false,
  props: {
    confirmAction: Boolean,
    cancelAction: Boolean,
    closeAction: Boolean,
    // Specifies which DOM element that this component should detach to.
    attach: {
      default: false
    },
    idContent: {
      type: String,
      default: 'content',
    },
  },
  emits: ['confirm', 'cancel']
}
</script>

<style scoped>
::v-deep(.modal-container) {
  display: flex;
  justify-content: center;
  align-items: center;
}

::v-deep(iframe .modal-content) {
  top: -40%; /* Hack because the modal is in an iframe... */
}

::v-deep(.modal-content) {
  position: relative;
  display: flex;
  flex-direction: column;
  max-height: 90%;
  max-width: 40%;
  margin: 0 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
}
.modal__title {
  margin: 0 2rem 0 0;
  font-size: 1.5rem;
  font-weight: 700;
  text-align: center;
}
.modal__content {
  flex-grow: 1;
}
.modal__action {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  padding: 1rem 0 0;
}
.modal__close {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
}

#app button.modal__close {
  border-radius: 100%;
  min-width: 0;
  border: none;
  padding: 6px;
  background-color: #D82034;
}
</style>

<style scoped>
.dark-mode div ::v-deep(.modal-content) {
  border-color: #2d3748;
  background-color: #1a202c;
}
</style>
